import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('moodPicker.vrun.component', () => import('./MoodPicker.vue'))
